import { useEffect, useCallback } from "react";
import { useFiscalStore } from "@/store/fiscal-store";
import { getWatchedDirectories, syncDirectoryHandle, verifyPermission } from "@/lib/local/ingest";
import { toast } from "sonner";

export function useFolderSync() {
  const { dashboard } = useFiscalStore();

  const runSync = useCallback(async () => {
    const dirs = await getWatchedDirectories();
    if (!dirs.length) return;

    for (const dir of dirs) {
      if (dir.active) {
        try {
          // Check permission silently
          // @ts-expect-error
          const status = await dir.handle.queryPermission({ mode: 'read' });
          if (status === 'granted') {
            await syncDirectoryHandle(dir.handle, {
              onDone: (d) => {
                if (d.inserted > 0) {
                  toast.success(`${d.inserted} novos arquivos sincronizados de ${dir.id}`, {
                    description: "Seu dashboard foi atualizado automaticamente.",
                    action: {
                      label: "Ver",
                      onClick: () => window.location.reload() // Or just trust the store sync
                    }
                  });
                }
              }
            });
          }
        } catch (err) {
          console.error("[FolderSync] Error during background sync:", err);
        }
      }
    }
  }, []);

  useEffect(() => {
    // Run once on mount
    runSync();

    // Poll every 60 seconds
    const interval = setInterval(runSync, 60000);
    return () => clearInterval(interval);
  }, [runSync]);
}
